import { get } from './get';
import { list } from './list';
export { type GenericEngineListQuery } from './list';
export { type GenericEngineGetQuery } from './get';

export const genericEngines = {
  get,
  list,
};
